import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { User_Interface } from 'src/app/Interface/User_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  GetRecord(): Observable<Array<User_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/User").pipe(
      map(data => {
        return data as Array<User_Interface>
      })
    )
  }

  GetLoging(Startdate: String,
    Enddate: String,
    id: number): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/User/GetLoging?startdate=" + Startdate
    + "&enddate=" + Enddate
    + "&id=" + id).pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )
  }

  GetError(Startdate: String,
    Enddate: String): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/User/GetError?startdate=" + Startdate
    + "&enddate=" + Enddate).pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )
  }

  GetLogingUrl(Startdate: String,
    Enddate: String,
    id: String): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/User/GetLogingUrl?startdate=" + Startdate
    + "&enddate=" + Enddate
    + "&id=" + id).pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )
  }


  GetSingle(id: Number): Observable<User_Interface> {
    return this.http.get(environment.BaseUrl + "Daro/User/GetSingle?id=" + id).pipe(
      map(data => {
        return data as User_Interface
      })
    )
  }

  ValidationCode(Number: String): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/User/ValidationCode?Number=" + Number).pipe(
      map(data => {
        return data as any
      })
    )
  }


  AddUser(
    model: User_Interface,
    ListMenu: Array<number>,
    ListRoleUser: Array<string>,
    DeviceBehfaRole: Array<number>,
    TicketCategory: Array<number>,
    ListDeviceBehfaRepair: Array<number>): Observable<User_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var modelCustomer = {
      id: model.id,
      username: model.username,
      password: model.password,
      type: model.type,
      create_ip: '',
      person_id: model.person_id,
      cutomer_id: model.cutomer_id,
      fname: model.fname,
      lname: model.lname,
      phone: model.phone,
      expert_calibration: model.expert_calibration,
      del: false,
      subdate: null
    }

    var body = {
      model: modelCustomer,
      ListMenu: ListMenu,
      ListRoleUser: ListRoleUser,
      TicketCategory: TicketCategory,
      ListDeviceBehfaRepair: ListDeviceBehfaRepair,
      DeviceBehfaRole: DeviceBehfaRole,
    }


    return this.http.post(environment.BaseUrl + "Daro/User/Add", body, { headers }).pipe(
      map(data => {
        return data as User_Interface
      })
    )

  }

  EditUser(
    model: User_Interface,
    ListMenu: Array<number>,
    ListRoleUser: Array<string>,
    DeviceBehfaRole: Array<number>,
    TicketCategory: Array<number>,
    ListDeviceBehfaRepair: Array<number>): Observable<User_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var modelCustomer = {
      id: model.id,
      expert_calibration: model.expert_calibration,
      username: model.username,
      password: model.password,
      type: model.type,
      create_ip: '',
      cutomer_id: model.cutomer_id,
      fname: model.fname,
      lname: model.lname,
      phone: model.phone,
      del: false,
      subdate: null
    }

    var body = {
      model: modelCustomer,
      ListMenu: ListMenu,
      ListRoleUser: ListRoleUser,
      TicketCategory: TicketCategory,
      ListDeviceBehfaRepair:ListDeviceBehfaRepair,
      DeviceBehfaRole: DeviceBehfaRole,
    }

    return this.http.post(environment.BaseUrl + "Daro/User/Edit", body, { headers }).pipe(
      map(data => {
        return data as User_Interface
      })
    )

  }

  DeleteUser(id: number): Observable<User_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/User/Delete?id=" + id ).pipe(
      map(data => {
        return data as User_Interface
      })
    )

  }


  GetLogingUrlUser():Observable<any>{
    return this.http.get(environment.BaseUrl +"Daro/User/GetLogingUrlUser").pipe(
      map(data=>{
        return data
      })
    )
  }


}
